import { HStack } from "@chakra-ui/react";

export default function FormFooter({ children }) {
  return (
    <HStack spacing="24px" mt={6} justify={"flex-end"} alignItems={"center"}>
      {children}
    </HStack>
  );
}
